import {apiUrl} from "@/router/apiBackRoutes";
import {getApp, toastMessage} from "@/utils/appInstance";


// API requests
export async function apiRequest(method, url, dados) {
    try {
        let finalUrl = url;

        if (method === 'GET' && dados && Object.keys(dados).length > 0) {
            const params = new URLSearchParams(dados).toString();
            finalUrl = `${url}${url.includes('?') ? '&' : '?'}${params}`;
        }

        const fetchOptions = {
            method: method,
            headers: {
                "Content-Type": "application/json",
            },
            credentials: 'include',
        };

        if (method !== 'GET') {
            fetchOptions.body = JSON.stringify(dados);
        }

        let response = await fetch(finalUrl, fetchOptions);

        if (response.status === 401) {
            // Se falhou ao tentar renovar, desloga
            if (url.includes('/usuarios/token/refresh/') || url.includes('/crm/token/refresh/')) {
                await logout();
                return {success: false, data: null, error: "Sessão expirada"};
            }

            // Tenta renovar o token silenciosamente
            const refreshResponse = await fetch(apiUrl.usuarios.tokenRefresh, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                credentials: 'include',
            });

            if (refreshResponse.ok) {
                // Tenta novamente a requisição original com o novo cookie de acesso
                response = await fetch(finalUrl, fetchOptions);
            } else {
                await logout();
                return {success: false, data: null, error: "Sessão expirada"};
            }
        }

        let responseData = null;

        if (response.status !== 204) {
            try {
                responseData = await response.json();
            } catch (error) {
                console.warn("Erro ao converter resposta para JSON:", error);
            }
        }

        if (!response.ok) {
            console.warn("Erro na requisição:", responseData);
            return {success: false, data: null, error: responseData || "Erro desconhecido"};
        }

        return {success: true, data: responseData, error: null};

    } catch (error) {
        console.error("Erro de conexão:", error);
        return {success: false, data: null, error: "Falha ao conectar ao servidor"};
    }
}

export function calculoDataPrevisao(dataInicio, tempoMeses) {
    let data;

    if (typeof dataInicio === "string") {
        let partes_data = dataInicio.split('-');
        let ano = parseInt(partes_data[0], 10);
        let mes = parseInt(partes_data[1], 10) - 1;
        let dia = parseInt(partes_data[2], 10);
        data = new Date(ano, mes, dia);
    } else if (dataInicio instanceof Date) {
        data = new Date(dataInicio);
    } else {
        return null;
    }

    data.setMonth(data.getMonth() + parseInt(tempoMeses, 10));

    let dia_previsto = data.getDate().toString().padStart(2, '0');
    let mes_previsto = (data.getMonth() + 1).toString().padStart(2, '0');
    let ano_previsto = data.getFullYear();

    return `${ano_previsto}/${mes_previsto}/${dia_previsto}`;
}


export function formatarMoeda(valor) {
    return Number(valor).toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    })
}


export async function logout() {
    let wasCliente = false;
    try {
        const isCliente = localStorage.getItem('clienteLogado');
        if (isCliente) {
            wasCliente = true;
        }

        if (!isCliente) {
            await fetch(apiUrl.usuarios.logout, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            });
        } else {
            await fetch(apiUrl.crm.logout, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                credentials: 'include'
            });
        }
    } catch (error) {
        console.error('Erro ao tentar fazer logout:', error);
    } finally {
        localStorage.removeItem('authToken');
        localStorage.removeItem('accessToken');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('isStaff');
        localStorage.removeItem('clienteLogado');
        localStorage.removeItem('isAuthenticated');
        toastMessage("success", "Logout realizado com sucesso!");
        if (wasCliente) {
            window.location.href = '/crm/login';
        } else {
            window.location.href = '/login';
        }
    }
}

export function alertDelete(id, url, titulo, mensagem, onSuccess = null) {
    const appInstance = getApp();

    if (!appInstance) {
        console.error("⚠️ App Vue não inicializado em funcoes.js");
        return;
    }

    appInstance.config.globalProperties.$confirm.require({
        message: mensagem,
        header: titulo,
        rejectLabel: "Cancelar",
        acceptLabel: "Confirmar",
        rejectClass: "p-button-danger order-2",
        acceptClass: "p-button-success order-1",
        accept: async () => {
            try {
                const response = await fetch(url, {
                    method: "DELETE",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    credentials: 'include',
                });

                if (response.ok) {
                    document.getElementById(`linha_${id}_img`)?.remove();
                    document.getElementById(`linha_${id}`)?.remove();

                    toastMessage("success", "Sucesso", "Registro removido com sucesso");

                    if (typeof onSuccess === "function") {
                        onSuccess();
                    }
                } else {
                    const data = await response.json();
                    toastMessage("warn", "Atenção", data.detail);
                }
            } catch (err) {
                console.error("Erro ao deletar:", err);
                toastMessage("error", "Erro", "Ocorreu um erro inesperado");
            }
        },
        reject: () => {
            toastMessage("info", "Cancelado", "Ação de exclusão foi cancelada");
        },
    });
}

export function parseDateFromBackend(dateStr) {
    if (!dateStr) return null;
    const [ano, mes, dia] = dateStr.split('-').map(Number);
    return new Date(ano, mes - 1, dia);
}

export function formatDateForBackend(date) {
    if (!date) return null;
    const ano = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const dia = String(date.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
}

export function normalizeDates(obj, fields) {
    fields.forEach(field => {
        if (obj[field] != null) {
            obj[field] = parseDateFromBackend(obj[field]);
        }
    });
}

export function denormalizeDates(obj, fields) {
    fields.forEach(field => {
        if (obj[field] instanceof Date) {
            obj[field] = formatDateForBackend(obj[field]);
        }
    });
}

export function cpfValido(input) {
    if (!input) return false;

    const cpf = String(input).replace(/\D/g, '');

    if (cpf.length !== 11) return false;

    if (/(\d)\1{10}$/.test(cpf)) return false;

    const calcDigito = (base, pesoInicial) => {
        let soma = 0;
        for (let i = 0; i < base.length; i++) {
            soma += Number(base[i]) * (pesoInicial - i)
        }
        const resto = soma % 11;
        return resto < 2 ? 0 : 11 - resto;
    };

    const base9 = cpf.slice(0, 9);
    const dig1 = calcDigito(base9, 10);
    const base10 = base9 + String(dig1);
    const dig2 = calcDigito(base10, 11)

    return cpf.endsWith(String(dig1) + String(dig2));
}
